import { render, staticRenderFns } from "./HomeTemplate.vue?vue&type=template&id=6ef1a04e&scoped=true"
import script from "./HomeTemplate.vue?vue&type=script&lang=ts"
export * from "./HomeTemplate.vue?vue&type=script&lang=ts"
import style0 from "./HomeTemplate.vue?vue&type=style&index=0&id=6ef1a04e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1a04e",
  null
  
)

export default component.exports